<template>
  <Layout>
    <PageHeader :title="title" :breadcrumbs="breadcrumbs"/>
    <form @submit="onSubmit">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="outer-repeater">
                <div data-repeater-list="outer-group" class="outer">
                  <div data-repeater-item class="outer">
                    <div class="form-group row mb-4">
                      <div class="col-form-label col-lg-2">
                        <label for="title">
                          {{ $t("departments.edit.form.name") }}
                        </label>
                        <i
                          class="fa fa-info-circle ml-1"
                          aria-hidden="true"
                          v-b-popover.hover.topright="$t('charlength-info.message')"
                          :title="$t('charlength-info.title')">
                        </i>
                      </div>
                      <div class="col-lg-10">
                        <b-form-input
                          id="title"
                          name="title"
                          type="text"
                          value="department.title"
                          v-model="$v.department.title.$model"
                          class="form-control"
                          :state="validateField('title')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback>
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label
                      for="description"
                      class="col-form-label col-lg-2">
                      {{ $t("departments.edit.form.description") }}
                      </label>
                      <div class="col-lg-10">
                        <input
                          id="description"
                          name="description"
                          type="text"
                          value="department.description"
                          v-model="department.description"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <b-tabs content-class="mt-3">
                      <b-tab :title='$t("talents.form.title")' key="talents" active>
                        <talents-table
                          v-if="allTalents"
                          :talents="allTalents"
                          :allDepartments="allDepartments"
                          :readonly="true"
                          :showTitle="false"
                          @talentsTableUpdate="updateChosenTalents($event)"
                        />
                      </b-tab>
                      <b-tab :title='$t("departments.users.form.title")' key="users">
                        <users-table
                          v-if="allUsers"
                          :allUsers="allUsers"
                          :readonly="true"
                          :showTitle="false"
                        />
                      </b-tab>
                    </b-tabs>

                    <div class="form-group row mb-4">
                      <label
                      for="parent-department"
                      class="col-form-label col-lg-2">
                      {{ $t("departments.edit.form.parent-department") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-select
                          name="parent-department"
                          id="parent-department"
                          v-model="department.parentId"
                          :options="allDepartments"
                          text-field="title"
                          value-field="id"
                          value="department.parent"
                        ></b-form-select>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
              <div class="row justify-content-end">
                <div class="col-12">
                  <button type="submit" class="btn btn-primary m-2">
                    <i class="fa fa-users" aria-hidden="true"></i>
                    {{ $t("departments.edit.form.update-department-button") }}
                  </button>
                  <button @click="$router.go(-1)" type="button" class="btn btn-secondary m-2">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    {{ $t("go-back") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </Layout>
</template>

<script>
import i18n from "@/i18n";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import UsersTable from "@/router/views/departments/users-table";
import TalentsTable from "@/router/views/tasks/partials/talents-table";
import { userService } from "@/helpers/services/user/userService";
import { required } from "vuelidate/lib/validators";


const page = {
    title: i18n.t("departments.edit.header"),
    meta: [{ name: "description", content: appConfig.description }]
  };

const components = {
  Layout,
  PageHeader,
  UsersTable,
  TalentsTable
  }

export default {
  name: "DepartmentEdit",
  page,
  components,
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {text: i18n.t('departments.overview.header'), href: "/departments"},
        {text: i18n.t('departments.edit.header'), active: true},
      ],
      department: {},
      oldDepartmentTitle: "",
      title: i18n.t('departments.edit.header'),
      allDepartments: [],
      allUsers: null,
      allTalents: null,
    };
  },
  validations: {
    department: {
      title: {
        required,
      },
    }
  },
  methods: {
    validateField(name) {
      const { $dirty, $error } = this.$v.department[name];
      return $dirty ? !$error : null;
    },
    onSubmit(e) {
      e.preventDefault();
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      userService.updateDepartment(this.department);
    },
    async fetchDataForDepartmentToEdit() {
      this.department = await userService.fetchDepartmentDetails(this.id);
      this.oldDepartmentTitle = this.department.title;
    },
  },
  created() {
    this.fetchDataForDepartmentToEdit();
    userService.fetchDepartments()
      .then(departments => {
        this.allDepartments = departments.filter(d => d.id !== this.id);
      });
    userService.fetchDepartmentUsers(this.id)
      .then(e => this.allUsers = e);
    userService.fetchDepartmentTalents(this.id)
      .then(t => this.allTalents = t);
  },
};
</script>
